<template>
    <img
        :src="require('@/assets/wind/' + this.direction + '.png')"
        :alt="this.direction"
        class="wind-icon"
    />
</template>

<script>
export default {
    name: 'WindChart',
    props: {
        chartId: {
            type: String,
            default: 'line-chart',
        },
        cssClasses: {
            type: String,
            default: '',
        },
        direction: {
            type: String,
            default: '北',
        },
    },
}
</script>

<style lang="scss" scoped>
.wind-icon {
    height: 100%;
    width: auto;
}
</style>
